import React from 'react';
import ReactDOM from 'react-dom/client';
import axios from 'axios';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Sessão agora vive num cookie httpOnly (setado pelo backend no login) em vez
// de localStorage — precisa enviar cookies em toda chamada cross-site.
axios.defaults.withCredentials = true;

// O valor do csrfToken é ecoado num header próprio em toda requisição que
// muda estado — padrão double-submit cookie, exigido pelo backend pra
// aceitar auth via cookie (ver src/middleware/auth.js no backend). Chamadas
// autenticadas via Authorization Bearer não precisam disso, mas mandar o
// header não atrapalha nelas.
//
// O valor vem do localStorage (salvo em auth/Login.js a partir do corpo da
// resposta de /login), não de document.cookie: em produção o front e o
// backend ficam em domínios diferentes, e cookie setado pelo backend não é
// legível via JS na página do front (cookie é isolado por domínio, não por
// porta como em dev local).
axios.interceptors.request.use((config) => {
  const csrfToken = localStorage.getItem('csrfToken');
  if (csrfToken) {
    config.headers['X-CSRF-Token'] = csrfToken;
  }
  return config;
});

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
